import React, { useEffect } from 'react'
import { Layout } from 'antd'
import { Routes, Route, useNavigate } from 'react-router-dom'
import { SettingsTabs } from './SettingsTabs'
import { usePageTitle } from '../../utils/pageTitle'
import { Navigation } from '../../components/Navigation/Navigation'
import { XeroSettings } from './Integrations/XeroSettings'
import { UserPage } from './UserManagement/UserPage'
import { useCompanyStore, usePermissions } from '../../store/company/companyStore'
import { NewUserPage } from './UserManagement/NewUserPage'
import { LoginAsUserPage } from './LoginAsUserPage'

const { Content } = Layout

export const SettingsPage: React.FC = () => {
  usePageTitle('Settings')
  const navigate = useNavigate()
  const { hasPermissions, permissions } = usePermissions()
  const user = useCompanyStore((state) => state.user)

  useEffect(() => {
    if (!hasPermissions(['organisationManagement'])) {
      navigate('/app/documents')
    }
  }, [permissions])

  return (
    <Layout className="min-h-screen">
      <Navigation />

      {hasPermissions(['organisationManagement']) && (
        <Content className="bg-gray-50">
          <div className="max-w-4xl mx-auto p-6">
            <Routes>
              <Route path="/integrations/xero" element={<XeroSettings />} />
              <Route path="/users/new" element={<NewUserPage />} />
              <Route path="/users/:id" element={<UserPage />} />
              {user?.isGlobalAdmin && (
                <Route path="/login-as" element={<LoginAsUserPage />} />
              )}
              <Route path="*" element={<SettingsTabs />} />
            </Routes>
          </div>
        </Content>
      )}
    </Layout>
  )
}
